import { apiClient } from '../../../shared/services/apiClient';
import {
    TestimonialListResponse,
    TestimonialSingleResponse,
    TestimonialStatus,
} from '../types/testimonial.types';

export const testimonialService = {
    fetchPublic: () =>
        apiClient.get<{ msg: string; data: import('../types/testimonial.types').ITestimonial[] }>('/testimonials/public'),

    fetchAll: (params?: { page?: number; limit?: number; status?: string }) =>
        apiClient.get<TestimonialListResponse>('/testimonials', { params }),

    fetchById: (id: string) =>
        apiClient.get<TestimonialSingleResponse>(`/testimonials/${id}`),

    create: (formData: FormData) =>
        apiClient.post<TestimonialSingleResponse>('/testimonials', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),

    update: (id: string, formData: FormData) =>
        apiClient.put<TestimonialSingleResponse>(`/testimonials/${id}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),

    toggleStatus: (id: string, status: TestimonialStatus) =>
        apiClient.patch<TestimonialSingleResponse>(`/testimonials/${id}/status`, { status }),

    reorder: (items: { id: string; displayOrder: number }[]) =>
        apiClient.patch('/testimonials/reorder', { items }),

    remove: (id: string) =>
        apiClient.delete(`/testimonials/${id}`),
};
